import { JSX, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useInView } from "react-intersection-observer";

import NotificationsList from "@/components/notifications/NotificationsList.tsx";

import { useNotificationsList } from "@/hooks/api/user.hooks.ts";

const NotificationsPage = (): JSX.Element => {
  const { t } = useTranslation();
  const { data, fetchNextPage, hasNextPage, isLoading } = useNotificationsList(25);

  const { ref, inView } = useInView();

  useEffect(() => {
    if (inView && hasNextPage) {
      fetchNextPage();
    }
  }, [inView, hasNextPage, fetchNextPage]);

  const flattenData = data ? data.pages.flatMap((page) => page.results) : [];

  console.log(flattenData);
  return (
    <section className={"rounded-7.5 py-10 max-md:py-6"}>
      <h1 className={"border-b border-b-surface-container pb-10 text-4xl font-semibold max-lg:pb-6 max-lg:text-2xl"}>
        {t("General.notifications")}
      </h1>
      {isLoading && (
        <div className="flex flex-col gap-5 divide-y divide-surface-container">
          {Array.from({ length: 4 }).map((_, index) => (
            <div key={index} className="aspect-[1432/240] overflow-hidden rounded-xl max-md:aspect-[701/523]">
              <div className="mb-5 h-full w-full bg-surface-bright"></div>
            </div>
          ))}
        </div>
      )}
      {flattenData && flattenData.length ? (
        <>
          <NotificationsList notifications={flattenData} />
          <div ref={ref} />
        </>
      ) : null}
    </section>
  );
};

export default NotificationsPage;
